import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { invoiceAPI } from '../services/api';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [totalPaid, setTotalPaid] = useState<number>(0);
  const [loadingPaid, setLoadingPaid] = useState<boolean>(true);
  const [errorPaid, setErrorPaid] = useState<string>('');

  const formatPrice = (price: number) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(price);

  useEffect(() => {
    const fetchPaidTotal = async () => {
      try {
        setLoadingPaid(true);
        const res = await invoiceAPI.getAll();
        const invoices = res.data || [];
        const sum = invoices
          .filter((inv: any) => inv.status === 'PAGADA')
          .reduce((acc: number, inv: any) => acc + (inv.total || 0), 0);
        setTotalPaid(sum);
      } catch (e) {
        setErrorPaid('No se pudo cargar el total de facturas pagadas');
      } finally {
        setLoadingPaid(false);
      }
    };
    fetchPaidTotal();
  }, []);

  const menuItems = [
    { title: 'Clientes', description: 'Gestionar clientes', path: '/clients', icon: '👥' },
    { title: 'Productos', description: 'Gestionar productos', path: '/products', icon: '📦' },
    { title: 'Presupuestos', description: 'Crear y gestionar presupuestos', path: '/quotes', icon: '📋' },
    { title: 'Facturas', description: 'Crear y gestionar facturas', path: '/invoices', icon: '🧾' },
  ];

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <h1>Bienvenido, {user?.username}</h1>
          <p className="text-muted">Sistema de Facturación - Panel de Control</p>
        </Col>
      </Row>
      <Row>
        {/* Tarjeta resumen: Total facturas pagadas */}
        <Col md={6} lg={3} className="mb-4">
          <Card className="h-100">
            <Card.Body className="text-center d-flex flex-column">
              <div style={{ fontSize: '3rem' }}>✅</div>
              <Card.Title className="mt-3">Facturas pagadas</Card.Title>
              {errorPaid ? (
                <Card.Text className="text-danger">{errorPaid}</Card.Text>
              ) : loadingPaid ? (
                <div className="d-flex justify-content-center align-items-center flex-grow-1">
                  <div className="spinner-border" role="status" />
                </div>
              ) : (
                <Card.Text className="fs-3 fw-bold">{formatPrice(totalPaid)}</Card.Text>
              )}

            </Card.Body>
          </Card>
        </Col>
        {menuItems.map((item, index) => (
          <Col md={6} lg={3} key={index} className="mb-4">
            <Card className="h-100">
              <Card.Body className="text-center">
                <div style={{ fontSize: '3rem' }}>{item.icon}</div>
                <Card.Title className="mt-2">{item.title}</Card.Title>
                <Card.Text>{item.description}</Card.Text>
                <Button 
                  variant="primary" 
                  onClick={() => navigate(item.path)}
                  className="mt-auto"
                >
                  Acceder
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Dashboard;
